module.exports = __webpack_public_path__ + "img/icon_duihao-mian.c04b61bf.png";